import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import webDevelopment from "../images/web-service.png";
import { Helmet } from "react-helmet-async";

export default function Webdevelopmentservices() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  const processSteps = [
    { icon: "fa-globe", title: "Securing Domain", desc: "We protect your brand identity with secure domain registration, SSL setup, and advanced security configurations from day one." },
    { icon: "fa-search", title: "Competitor Analysis", desc: "In-depth research of your competitors’ strengths, weaknesses, UX, and SEO strategies to give you a clear competitive advantage." },
    { icon: "fa-file-lines", title: "SEO-Focused Content", desc: "Strategic, keyword-optimized content creation that ranks higher, engages visitors, and converts better." },
    { icon: "fa-mobile-screen", title: "Responsive & Modern Design", desc: "Pixel-perfect, mobile-first designs that look stunning and perform flawlessly on every device and screen size." },
  ];

  const websiteTypes = [
    { icon: "fa-building-columns", title: "Corporate Website", desc: "Professional, trustworthy online presence that communicates your brand values, services, team, and achievements with clarity and elegance." },
    { icon: "fa-graduation-cap", title: "Educational Website", desc: "Interactive learning platforms with course catalogs, student portals, e-learning integration, and resource-rich layouts." },
    { icon: "fa-cart-shopping", title: "E-commerce Website", desc: "High-conversion online stores with secure checkout, product filters, payment gateways, inventory sync, and mobile-optimized shopping." },
    { icon: "fa-briefcase", title: "Services Website", desc: "Service-focused sites highlighting expertise, case studies, testimonials, booking forms, and clear calls-to-action." },
    { icon: "fa-images", title: "Portfolio Website", desc: "Visually stunning showcases for creatives — photographers, designers, artists — with elegant galleries and project storytelling." },
    { icon: "fa-newspaper", title: "Blogging / Content Website", desc: "SEO-optimized, fast-loading blogs or news sites with powerful CMS, beautiful typography, and reader engagement features." },
  ];

  return (
    <div>
      <Helmet>
        <title>Professional Web Design & Development Services - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/web-development-services/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Web Development Services
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row align-items-center g-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
            <div className="section-title text-start mb-4">
              <h2>Our Web Services</h2>
              <h3 style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                Grow Your Business With <span>Modern Web Solutions</span>
              </h3>
            </div>
            <p style={{ textAlign: "justify", lineHeight: 1.8, fontSize: "1.05rem" }}>
              A powerful website is no longer optional — it's your 24/7 digital salesperson, brand ambassador, and trust builder. We combine stunning design, blazing-fast performance, mobile-first responsiveness, and SEO intelligence to create websites that attract, engage, and convert.
            </p>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              Whether you're launching a new brand, revamping an existing site, or building a full-scale e-commerce platform, our experienced team delivers pixel-perfect, future-ready websites that help you stand out in 2025 and beyond.
            </p>
          </div>

          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
            <img
              src={webDevelopment}
              alt="Web Development Services"
              className="img-fluid "
              style={{ borderRadius: "16px" }}
            />
          </div>
        </div>
      </div>

      {/* How We Do It - Process Cards */}
      <div className="container my-1 py-1" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-1">
          <h3>How We Build Exceptional Websites</h3>
        </div>
        <div className="row g-4">
          {processSteps.map((item, i) => (
            <div className="col-lg-3 col-md-6" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '16px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <i
                  className={`fa-solid ${item.icon} fa-4x mb-4`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <h5 className="mb-3 fw-bold">{item.title}</h5>
                <p className="mb-0 small" style={{ lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Types of Websites - Card Grid */}
      <div
        className="container-fluid py-5"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}08 0%, #f8f9fa 100%)`,
        }}
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="section-title text-center mb-2">
            <h2>Diverse Website Solutions</h2>
            <p className="lead">Tailored Websites • Infinite Possibilities • One Trusted Partner</p>
          </div>

          <div className="row g-4">
            {websiteTypes.map((item, i) => (
              <div className="col-lg-4 col-md-6" key={i}>
                <div
                  className="card shadow-sm h-100"
                  style={{
                    transition: 'all 0.28s ease',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    border: '1px solid #e0e0e0',
                    backgroundColor: '#ffffff',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = primaryColor;
                    e.currentTarget.style.color = '#ffffff';
                    e.currentTarget.style.transform = 'translateY(-10px) scale(1.03)';
                    e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.15)';
                    e.currentTarget.style.borderColor = primaryColor;
                    const icon = e.currentTarget.querySelector('i');
                    if (icon) icon.style.color = '#ffffff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'white';
                    e.currentTarget.style.color = 'inherit';
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                    e.currentTarget.style.borderColor = '#e0e0e0';
                    const icon = e.currentTarget.querySelector('i');
                    if (icon) icon.style.color = primaryColor;
                  }}
                >
                  <div className="card-body text-center p-4">
                    <i
                      className={`fa-solid ${item.icon} fa-3x mb-3`}
                      style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                    ></i>
                    <h5 className="card-title mb-3 fw-bold">{item.title}</h5>
                    <p className="card-text small" style={{ minHeight: "100px" }}>
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Final Call to Action / Closing */}
      <div className="container my-1 py-1 text-center" data-aos="fade-up" data-aos-duration="1000">
        <h3 className="mb-4" style={{ fontWeight: 700 }}>
          Ready to Build a Website That Performs?
        </h3>
        <p className="lead mb-4" style={{ maxWidth: "800px", margin: "0 auto" }}>
          Let’s create a modern, fast, SEO-friendly, conversion-focused website that grows your business — not just looks good.
        </p>
 <a
  href="/contact"
  className="primaryBtn px-4 py-2 mb-3"
  style={{ display: "inline-block" }}
>
  Get Your Free Quote Today &rarr;
</a>


      </div>
    </div>
  );
}